import React, { Fragment } from 'react';
import { HeadProps, HeadFC } from 'gatsby';
import { useMetadata } from 'src/util/hooks';
import { useLocation } from '@reach/router';

import ogImage from './og-image.jpg';

type Props = {
    title?: string;
    description?: string;
    keywords?: string;
};
export default function Seo(props: Props) {
    const { title, description, keywords } = useMetadata();
    const location = useLocation();

    const $title = `${props.title ? `${props.title} – ` : ''}${title}`;
    const $description = props.description || description;
    const $keywords = props.keywords || keywords;
    const ogImageAbsoluteUrl = ogImage.replace(/^\//, `${location.origin}/`);

    return (
        <Fragment>
            <title children={$title} />
            <meta name="keywords" content={$keywords} />
            <meta name="description" content={$description} />

            <meta property="og:title" content={$title} />
            <meta property="og:description" content={$description} />
            <meta property="og:image" content={ogImageAbsoluteUrl} />
            <meta property="og:type" content="website" />
        </Fragment>
    );
}

type Frontmatter = {
    title: string;
    description?: string;
    keywords?: string;
};
type HeadPageContext = {
    slug?: string;
    langKey?: string;
    frontmatter?: Frontmatter;
};
export function createHead(overwrites?: Partial<Frontmatter>): HeadFC<object, HeadPageContext> {
    return (props: HeadProps<object, HeadPageContext>) => {
        const fm = props.pageContext.frontmatter;
        return (
            <Seo
                title={overwrites?.title ?? fm?.title}
                keywords={overwrites?.keywords ?? fm?.keywords}
                description={overwrites?.description ?? fm?.description}
            />
        );
    };
}
